/** Document uploads include browser preparation, network transfer, storage and MIME inspection. */
export const DOCUMENT_UPLOAD_TIMEOUT_MS = 180_000;

/**
 * Inspection videos are recorded for up to one minute and can be tens of MB.
 * The global 30s API timeout is shorter than a legitimate mobile upload, so a
 * route-specific ceiling keeps the request alive on slower connections.
 */
export const INSPECTION_VIDEO_UPLOAD_TIMEOUT_MS = 300_000;
